export default {
    items:[""],
    selectedProp:"display",
    flexProps:{
      "display":{
        "values":[
                  "flex",
                  "inline-flex",
                 
                  "inherit",
                  "initial"
          ],
          "selection":"flex"
      },
      "flex-direction":{
        values:[
          "row",
          "row-reverse",
          "column",
          "column-reverse",
          "inherit",
          "initial"
        ],
        selection:"row"
      },
      "flex-wrap":{
        values:[
          "nowrap",
          "wrap",
          "wrap-reverse",
          "inherit",
          "initial"
        ],
        selection:"initial"
      },
      "justify-content":{
          values:[
                     "center",
                     "flex-start",
                     "flex-end",
                     "space-between",
                     "space-around",
                     "space-evenly",
                     "inherit",
                     "initial"
          ],
          selection:"initial"
      },
      "align-items":{
          values:[
            "center",
            "flex-start",
            "flex-end",
            "baseline",
            "stretch",
            "inherit",
            "initial"
          ],
          selection:"initial"
      },
      "align-content":{
        values:[
          "flex-start",
          "flex-end",
          "center",
          "space-between",
          "space-around",
          "stretch",
          "inherit",
          "initial"
        ],
        selection:"initial"
      },

    }
  }


// WEBPACK FOOTER //
// ./src/components/flexbox/data.js